import {createAction, props} from '@ngrx/store';
import {Chacra} from "../../../chacra-core/models/chacra";

export const uiMapChangeChacra = createAction(
  '[UI] - Map - Change Chacra',
  props<{ chacra: Chacra }>()
);

